import axiosInstance from "../../../../../axiosInstance";
import {useCallback, useEffect, useState} from 'react';

const useGetCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(() => {
    setLoading(true)
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = "/services/projectmanagement/api/categories"
    const fullUrl = baseUrl + endpoint;

    axiosInstance
      .get(fullUrl, {
        params: {
          sort: 'name',
          'enabled.equals': true,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch(console.error)
      .finally(() => {
        setLoading(false)
      });
  }, [])

  useEffect(() => {
    getData()
  }, [getData])

  return {data, loading};
}

export default useGetCategories;
